var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Card } from "@consta/uikit/Card";
import { Text } from "@consta/uikit/Text";
import { IconArrowRight } from "@consta/icons/IconArrowRight";
import { useNavigate } from "react-router";
import styles from "./StartingPage.module.scss";
import { fitredRoutes } from "./routes";
import { Layout } from "@consta/uikit/Layout";
var StartingPage = function () {
    var navigate = useNavigate();
    function handleClick(url) {
        navigate(url);
    }
    return (_jsxs("div", __assign({ className: styles.body }, { children: [_jsx(Text, __assign({ size: "xl", weight: "semibold", className: styles.title }, { children: "\u0421\u043F\u0438\u0441\u043E\u043A \u0441\u0435\u0440\u0432\u0438\u0441\u043E\u0432" })), _jsx(_Fragment, { children: fitredRoutes.map(function (route) { return (_jsx(_Fragment, { children: _jsx(Card, __assign({ className: styles.cardContainer, verticalSpace: "s", horizontalSpace: "s", onClick: function () { return handleClick(route.url); }, border: true }, { children: _jsxs(Layout, __assign({ className: styles.card }, { children: [_jsx(Text, { children: route.label }), _jsx(IconArrowRight, {})] })) }), route.id) })); }) })] })));
};
export default StartingPage;
